import React, {ReactNode} from "react";
import {ListItemIcon, ListItemText, MenuItem} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import {PageAction} from "../../../components/page-action/PageActionHandler";
import {SeatingPlanModel} from "../SeatingPlanModel";

export function exportCsvMenuItem({label, tooltip}: {
    label: string,
    tooltip?: ReactNode,
}): PageAction<SeatingPlanModel> {
    return {
        type: 'menu-item',
        component: (_, handle) => (
            <SeatingPlanExportMenuItem
                label={label}
                tooltip={tooltip}
                onClick={handle}
                key={label}
            />
        ),
    };
}

function SeatingPlanExportMenuItem({label, tooltip, onClick}: {
    label: string,
    tooltip?: ReactNode,
    onClick: () => void,
}) {
    return (
        <MenuItem onClick={onClick}>
            <ListItemIcon>
                <DownloadIcon/>
            </ListItemIcon>
            <ListItemText
                primary={label}
                secondary={tooltip}
            ></ListItemText>
        </MenuItem>
    );
}